module.exports = __webpack_public_path__ + "assets/img/page_7.6964e66d.png";